import { GLDistributionTable } from "../../../../settlement/src/GLDistributionTable";
import { TimecardHistoryDetails } from "../../../../settlement/src/TimecardHistoryDetails";
import { Checkbox, DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeTimecardHistory extends Layout {
    checkboxIsVoid: Checkbox;
    dataheaderTimecardHistory: DataHeader;
    layoutGLDistributionTable: GLDistributionTable;
    layoutTimecardDetails: TimecardHistoryDetails;
    sourceJournalOffice: DataSource;
    sourceTimecardHist: DataSource;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabTimecard: Tab;
    tabsetTImecard: Tabset;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxPayeeId: Textbox;
    textboxVoidDate: Textbox;
}
